export const text = {
  title: 'Apply For Financing',
  noOptionAvailable: 'No Option Available',
  OptionsAvailable: 'Financing Options Available',
};
